const ufeApi = require('services/api/ufeApi');
const { UUIDv4 } = require('utils/UUID');
const { sha256 } = require('utils/Hashing.js');
const { isAuthServiceEnabled } = require('utils/Authentication');

// https://jira.sephora.com/wiki/display/ILLUMINATE/Login+API

function login({ deviceFingerprint, login: log1n, password, options }) {
    const {
        loginForCheckout, isKeepSignedIn, isOrderConfirmation, biAccountInfo, extraParams
    } = options;

    let body = {
        login: log1n,
        password,
        ...(isKeepSignedIn && deviceFingerprint && { deviceFingerprint })
    };

    if (isOrderConfirmation) {
        body.source = 'orderConfirmation';

        if (biAccountInfo) {
            body.isJoinBi = biAccountInfo.isJoinBi;
            body.biAccount = biAccountInfo.birthday;
            body.subscription = biAccountInfo.subscription;
        }
    } else {
        body.loginForCheckout = loginForCheckout;
        body.isKeepSignedIn = isKeepSignedIn;
    }

    if (extraParams) {
        body = {
            ...body,
            ...extraParams
        };
    }

    if (isAuthServiceEnabled()) {
        body.email = body.login;
        delete body.login;
        const randomNumber = UUIDv4();

        return sha256(randomNumber).then(function (digest) {
            const token = digest;
            body.randomNumber = token;

            return ufeApi
                .makeRequest('/api/auth/v1/login', {
                    method: 'POST',
                    body: JSON.stringify(body),
                    headers: { 'Content-type': 'application/json' }
                })
                .then(tokenData => {
                    if (tokenData?.errors) {
                        return Promise.reject(tokenData.errors[0]);
                    }

                    body.token = tokenData.token;
                    body.randomNumber = randomNumber;

                    return ufeApi
                        .makeRequest('/api/auth/v1/generateToken', {
                            method: 'POST',
                            body: JSON.stringify(body),
                            headers: {
                                'Content-type': 'application/json',
                                'x-requested-source': Sephora.channel
                            }
                        })
                        .then(data => (data?.errors ? Promise.reject(data.errors[0]) : data));
                });
        });
    }

    const url = '/api/auth/login';

    return ufeApi
        .makeRequest(url, {
            method: 'POST',
            body: JSON.stringify(body),
            headers: { 'Content-type': 'application/json' }
        })
        .then(data => (data.errorCode ? Promise.reject(data) : data));
}

module.exports = { login };
